import { Divider } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
// import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getAllFarmsList,
  getAllSubFarmsList,
  updateFarmId
} from "../../../modules/farmManagement/action";
import { isAuthorized, isSuperAdmin } from "../../Common/CheckAuthorization";
import Dropdown from "../../FormElement/Dropdown";
import Select from "react-select";
import "../../../style";
import "../../FormElement/dropdown.css";

const styles = theme => ({
  buttonText: {
    "& fieldset": {
      borderColor: "transparent !important",
      borderBottom: "1px solid #ccc !important",
      borderRadius: "0"
    }
  },
  formControl: {
    minWidth: 200
  },
  iconDrop: {
    display: "none"
  },
  mainRoot: {
    padding: "5px 14px"
  },
  menuOption: {
    "& a": {
      // color: 'red',
      textDecoration: "underline"
    }
  }
});

class FarmDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFarm: this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id
        ? userFarmDetail().id
        : DropdownOptions.ALL_MAIN_FARM.id,
      FillingForm: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.FillingForm &&
      nextProps.FillingForm !== this.props.FillingForm
    ) {
      this.setState({ FillingForm: nextProps.FillingForm });
    }
    if (nextProps.MainFarmId !== this.props.MainFarmId) {
      this.setState({ selectedFarm: nextProps.MainFarmId });
    }
  }
  componentDidMount() {
    if (this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.actions.getAllSubFarmsList(this.props.MainFarmId);
    } else if (!isSuperAdmin()) {
      this.props.actions.getAllFarmsList();
    }
  }

  handleChange = event => {
    const { value } = event;
    if (value === "farmMgmtLink")
      this.props.route.history.push("/subFarmsList");
    else {
      this.setState({ selectedFarm: value });
      this.props.actions.updateFarmId(value);
    }
  };

  getMainFarmName = MainFarmId => {
    if (MainFarmId === DropdownOptions.ALL_MAIN_FARM.id) {
      return [{ label: "All", value: "ALL_MAIN_FARM" }];
    } else {
      let farm = this.props.MainFarmsList.filter(
        farm => farm.id === MainFarmId
      );

      const mainFarm = farm.map(item => ({
        label: item.farmName,
        value: item.id
      }));
      return mainFarm;
    }
  };

  render() {
    const {
      classes,
      FarmsList,
      MainFarmId,
      route: { match }
    } = this.props;
    const { selectedFarm, FillingForm } = this.state;
    const isDisabled =
      match &&
      (match.path === "/app/createticket" ||
        match.path === "/app/editTicket" ||
        match.path === "/app/createcontract" ||
        match.path === "/app/editcontract" ||
        match.path === "/settings/users/create" ||
        match.path === "/settings/users/edit" ||
        match.path === "/subFarmsList" ||
        match.path === "/createSubFarm" ||
        match.path === "/farmmanagement/createmainfarm" ||
        match.path === "/farmmanagement/createsubfarm" ||
        match.path === "/farm-utilities" ||
        match.path === "/farmmanagement/edit" ||
        match.path === "/subFarmsList/edit" ||
        match.url === "/settings/mandatory-fields" ||
        match.url === "/settings/mandatory-fields/contract" ||
        match.path === "/farmsetup/farminformation/field-groups/create" ||
        match.path === "/farmsetup/farminformation/field-groups/edit" ||
        match.path === "/farmsetup/trucklines/create" ||
        match.path === "/farmsetup/trucklines/edit" ||
        match.path === "/farmsetup/destinations/internal/create" ||
        match.path === "/farmsetup/destinations/internal/edit" ||
        match.path === "/farmsetup/destinations/external/create" ||
        match.path === "/farmsetup/destinations/external/edit" ||
        match.path === "/farmsetup/counterparties/create" ||
        match.path === "/farmsetup/counterparties/edit" ||
        match.path ===
          "/farmsetup/farminformation/commodity-varieties/create" ||
        match.path === "/farmsetup/farminformation/commodity-varieties/edit" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/fields/create" ||
        match.path === "/farmsetup/farminformation/field-groups/fields/edit" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/indicators/create" ||
        match.path === "/farmsetup/farminformation/field-groups/fields" ||
        match.path === "/farmsetup/farminformation/field-groups/indicators" ||
        match.url === "/userManagement/edit" ||
        match.url === "/changepassword" ||
        match.path === "/help" ||
        match.path ===
          "/farmsetup/farminformation/field-groups/indicators/edit")
        ? true
        : FillingForm;

    const mainFarm = isSuperAdmin()
      ? MainFarmId === DropdownOptions.ALL_MAIN_FARM.id
        ? [{ label: "All", value: "ALL_MAIN_FARM" }]
        : this.getMainFarmName(MainFarmId)
      : [
          {
            label: `${userFarmDetail().name} [${userFarmDetail().farmId}]`,
            value: userFarmDetail().id
          }
        ];

    const subFarmList = FarmsList.map(item => ({
      label: item.name,
      value: item.id
    }));

    const allOptions = [...mainFarm, ...subFarmList];

    const groupedOptions = [
      {
        label: "Main Farm",
        options: mainFarm
      },
      {
        label: "Sub Farms",
        options: subFarmList
      }
    ];

    const selectedOption = allOptions.find(
      currentOption => currentOption.value === selectedFarm
    );

    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <div className="element_dropdown">
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              value={selectedOption}
              options={groupedOptions}
              onChange={this.handleChange}
              isDisabled={
                isDisabled ||
                !isAuthorized() ||
                (isSuperAdmin() &&
                  MainFarmId === DropdownOptions.ALL_MAIN_FARM.id)
              }
              theme={theme => ({
                ...theme,
                borderRadius: 4,
                colors: {
                  ...theme.colors,
                  primary25: "#f2f2f2",
                  primary: "#00000044",
                  primary50: "#f2f2f2"
                }
              })}
            />
            {/* <Select
          value={selectedFarm}
          onChange={this.handleChange}
          placeholder={"Farm"}
          input={
            <OutlinedInput
              name="selectFarm"
              labelWidth={0}
              // classes={{
              //     root: classNames(classes.buttonText),
              // }}
            />
          } */}
            {/* // classes={{ */}
            {/* //     icon: classNames(classes.iconDrop),
          //     select: classNames(classes.mainRoot)
          // }}
          name="selectedFarm"
          disabled={
            isDisabled ||
            !isAuthorized() ||
            (isSuperAdmin() && MainFarmId === DropdownOptions.ALL_MAIN_FARM.id)
          }
        >
          <MenuItem disabled value="">
            Main Farm
          </MenuItem>
          {isSuperAdmin() ? (
            MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
              <MenuItem value={MainFarmId}>
                {DropdownOptions.ALL_MAIN_FARM.name}
              </MenuItem>
            ) : (
              <MenuItem value={MainFarmId}>
                {this.getMainFarmName(MainFarmId)}
              </MenuItem>
            )
          ) : (
            <MenuItem value={userFarmDetail().id}>
              {`${userFarmDetail().name} [${userFarmDetail().farmId}]`}
            </MenuItem>
          )}
          <Divider />
          {FarmsList && FarmsList.length > 0 && (
            <MenuItem disabled value="">
              Sub Farms
            </MenuItem>
          )}
          <Divider />
          {FarmsList &&
            Object.keys(FarmsList).map(option => (
              <MenuItem key={option} value={FarmsList[option].id}>
                {`${FarmsList[option].name} [${FarmsList[option].farmId}]`}
              </MenuItem>
            ))}
          {/* <Divider /> */}
            {/* {isAuthorized() && (
            <MenuItem value="nothing" className={classes.menuOption}>
              <Link to="/subFarmsList">Farm Management</Link>
            </MenuItem>
          )}
        </Select> */}{" "}
            {/* */}
          </FormControl>
        </div>
      </FormControl>
    );
  }
}

FarmDropdown.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  return {
    FarmsList: state.FarmManagementReducer.FarmsList,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    FillingForm: state.FarmManagementReducer.FillingForm,
    MainFarmsList: state.FarmManagementReducer.MainFarmsList,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getAllFarmsList,
        getAllSubFarmsList,
        updateFarmId
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(FarmDropdown));



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/FarmDropdown.js